import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'link' | 'link-danger';

@Component({
    selector: 'lokos-button',
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss',
    standalone: false,
})
export class ButtonComponent {
    @Input() variant: ButtonVariant = 'primary';
    @Input() type: 'button' | 'submit' = 'button';
    @Input() disabled = false;
    @Input() label = '';
    @Output() clicked = new EventEmitter<MouseEvent>();

    onClick(event: MouseEvent) {
        if (!this.disabled) {
            this.clicked.emit(event);
        }
    }
}
